import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_8'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_8',
  name: "Which of the following topics are included within the facility's written policies and procedures for freedom of association and collective bargaining?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'RIGHT_TO_FREEDOM_OF_ASSOCIATION_RIGHT_TO_FORM_OR_JOIN_A_TRADE_U',
      text: 'Right to freedom of association / Right to form or join a trade union',
      externalIds: [
        {
          id: 'ms-1--10-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RIGHTS_TO_FREELY_CHOOSE_WORKER_REPRESENTATIVES_OR_FACILITY_COMM',
      text: 'Rights to freely choose worker representatives (or facility commitments to not obstruct this)',
      externalIds: [
        {
          id: 'ms-1--10-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RIGHTS_TO_BARGAIN_COLLECTIVELY',
      text: 'Rights to bargain collectively',
      externalIds: [
        {
          id: 'ms-1--10-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_AND_NON_RETALIATION_OF_WORKERS_ON_BASIS_OF_T_NON',
      text: 'Non-discrimination and non-retaliation of workers on basis of trade union membership/non-membership or activities',
      externalIds: [
        {
          id: 'ms-1--10-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_AND_NON_RETALIATION_OF_WORKERS_ON_BASIS_OF_T',
      text: 'Non-discrimination and non-retaliation of workers on basis of their worker representative role or activities',
      externalIds: [
        {
          id: 'ms-1--10-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DEMOCRATIC_ELECTION_AND_ENGAGEMENT_OF_WORKER_REPRESENTATIVES',
      text: 'Democratic election and engagement of worker representatives',
      externalIds: [
        {
          id: 'ms-1--10-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COMMUNICATIONS_AND_CONSULTATION_PROCESS',
      text: 'Communications and consultation process',
      externalIds: [
        {
          id: 'ms-1--10-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RIGHT_TO_PARTICIPATE_IN_STRIKES_INDUSTRIAL_ACTION',
      text: 'Right to participate in strikes / industrial action',
      externalIds: [
        {
          id: 'ms-1--10-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--10-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-1--10-9f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'RIGHT_TO_FREEDOM_OF_ASSOCIATION_RIGHT_TO_FORM_OR_JOIN_A_TRADE_U',
                'RIGHTS_TO_FREELY_CHOOSE_WORKER_REPRESENTATIVES_OR_FACILITY_COMM',
                'RIGHTS_TO_BARGAIN_COLLECTIVELY',
                'NON_DISCRIMINATION_AND_NON_RETALIATION_OF_WORKERS_ON_BASIS_OF_T_NON',
                'NON_DISCRIMINATION_AND_NON_RETALIATION_OF_WORKERS_ON_BASIS_OF_T',
                'DEMOCRATIC_ELECTION_AND_ENGAGEMENT_OF_WORKER_REPRESENTATIVES',
                'COMMUNICATIONS_AND_CONSULTATION_PROCESS',
                'RIGHT_TO_PARTICIPATE_IN_STRIKES_INDUSTRIAL_ACTION',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-23',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 19600,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
